import { useAppDispatch } from "@redux/hooks";
import { updatePassword } from "../../../write/application/use-cases/password-update/update-password";
import type { UserPassword } from "@user-management-context/write/domain/types/user";
import { PasswordUpdateContent } from "./password-update.content";

interface Props {
  userId: string;
  token: string;
  email: string;
}

export const PasswordUpdateContainer = ({ userId, token, email }: Props) => {
  const dispatch = useAppDispatch();

  const onSubmit = (body: UserPassword) => {
    dispatch(updatePassword(body));
  };

  return <PasswordUpdateContent onSubmit={onSubmit} userId={userId} token={token} email={email} />;
};
